import Headroom from 'headroom.js';
import Vue from 'vue';

export default new Vue({
    el: '#site-header',
    data() {
        return {
            menuOpen: false,
            headroom: null
        }
    },
    mounted() {
        var header = document.querySelector("header");
        var headroom  = new Headroom(header, {
            onTop : function() {
                this.headroom = 'headroom--top'
            },
            onNotTop: function() {
                this.he = 'headroom--not-top'
            }
        });
        headroom.init();
    },
    methods: {
        toggle() {
            this.menuOpen = !this.menuOpen;
        }
    },
    watch: {
        menuOpen: {
            immediate: true,
            handler: (show) => {
                if (show) {
                    document.body.style.setProperty('overflow', 'hidden');
                } else {
                    document.body.style.removeProperty('overflow');
                }
            }
        }
    }
})